export const classificationResultQueryKey = (classificationResultId: string | null | undefined) =>
  ["classification-result", classificationResultId] as const;
